(function(){
    if(!window.p_wcag_styles_001) {
        // 不重复加载
        window.p_wcag_styles_001 = true;
        
        // 判断是否是需要辅助的设备/用户
        function isAccessibilityUser() { const hasScreenReader = !!(window.navigator.accessibility || window.navigator.userAgent.includes('NVDA') || window.navigator.userAgent.includes('VoiceOver')); const isKeyboardNavigation = window.isKeyboardNav; return hasScreenReader || isKeyboardNavigation; }
        // 换一个同属性、同子节点的父元素
        function moveAllContentAndReplace(oldDivSelector, newTag) { const oldDiv = document.querySelector(oldDivSelector); if (!oldDiv) return; const newDiv = document.createElement(newTag || 'div'); Array.from(oldDiv.attributes).forEach(attr => { newDiv.setAttribute(attr.name, attr.value); }); while (oldDiv.firstChild) { newDiv.appendChild(oldDiv.firstChild); } oldDiv.parentNode.replaceChild(newDiv, oldDiv); }

        // 用了键盘的大概率就是辅助类
        document.addEventListener('keydown', (e) => { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') { window.isKeyboardNav = true; } });

        // 传统用户不是辅助类
        document.addEventListener('click', () => { window.isKeyboardNav = false; });
        document.addEventListener('touchstart', () => { window.isKeyboardNav = false; });

        // Golbal API: bind key event
        function handleKeyPress(dom, handle) { if(!dom) return; dom.addEventListener('keydown', (event) => { const isEnter = event.key === 'Enter' || event.keyCode === 13; const isSpace = event.key === 'Space' || event.keyCode === 32; if (isEnter || isSpace) { event.preventDefault(); if(handle) handle.call(); } }); }
        window.handleKeyPress2026_v1 = handleKeyPress;

        // ready loadings
        let onDomReady = (callback) => { if (document.readyState === 'interactive' || document.readyState === 'complete') { callback(); } else { document.addEventListener('DOMContentLoaded', callback); } };
        let readyHandles = [], countObject = {};

        // fixments 001: cart overlay
        function fixSlidecarthqOverlay() {
            if(!countObject.fixSlidecarthqOverlay) countObject.fixSlidecarthqOverlay = 0; if(countObject.fixSlidecarthqOverlay > 10) { if(window.tickSlidecarthqOverlay) clearTimeout(window.tickSlidecarthqOverlay); return; }
            let obj = document.querySelector(".slidecarthq-overlay");
            if(!obj) { if(window.tickSlidecarthqOverlay) clearTimeout(window.tickSlidecarthqOverlay); countObject.fixSlidecarthqOverlay += 1; window.tickSlidecarthqOverlay = setTimeout(fixSlidecarthqOverlay, 500); return; }
            // do-it area, controlled by `.slidecarthq-overlay`'s initialization
            // 1: fix slidecart-hq overlay
            obj.setAttribute("aria-label", "Slidecarthq Overlay");
            if(obj.nextElementSibling) {
                // 2: header fix, change tag to DIV
                //let sch = obj.nextElementSibling.querySelector("header");
                // sch.setAttribute("aria-label", "Header block of Slidecarthq 1");
                /*const newSch = document.createElement('div');
                newSch.className = sch.className;
                newSch.setAttribute("data-testid", sch.getAttribute("data-testid"));
                newSch.setAttribute("aria-label", "Header block of Slidecarthq");
                while (sch.firstChild) { newSch.appendChild(sch.firstChild); }
                sch.parentNode.replaceChild(newSch, sch);*/
                moveAllContentAndReplace("#slidecarthq", "aside");
                moveAllContentAndReplace("#slidecarthq header.header", "div");
                // 3: svg fix
                let icons = obj.nextElementSibling.querySelectorAll("svg");
                if(icons.length > 0) {
                    Array.from(icons).forEach((icon) => {
                        icon.setAttribute("aria-label", "Open chat");
                    });
                }
            }
        }
        readyHandles.push(fixSlidecarthqOverlay);

        // fixments 002: shopify preview bar
        function fixPBarNextFrame() {
            if(!countObject.fixPBarNextFrame) countObject.fixPBarNextFrame = 0; if(countObject.fixPBarNextFrame > 10) { if(window.tickPBarNextFrame) clearTimeout(window.tickPBarNextFrame); return; }
            let obj = document.querySelector("#PBarNextFrame");
            if(!obj) { if(window.tickPBarNextFrame) clearTimeout(window.tickPBarNextFrame); countObject.fixPBarNextFrame += 1; window.tickPBarNextFrame = setTimeout(fixPBarNextFrame, 500); return; }
            obj.setAttribute("title", "Shopify Preview Bar");
        }
        readyHandles.push(fixPBarNextFrame);

        // fixments 003: anchors
        function fixIndexAnchors() {
            // header
            let sh = document.querySelector("header.as-shopify-header");
            if(sh) sh.setAttribute("aria-label", "header block of this page");
            // header - nav - cart
            let a1 = document.querySelector("a#as-cart-icon-bubble-web.dropdown-toggle.icon-btn.gray-600.lh-1.nav-link.nav-link-highlight");
            let a1Mobile = document.querySelector("a#as-cart-icon-bubble.position-relative.icon-btn.lh-1.icon-wrapper.flex-center.lead.nav-fw.nav-link.gray-600");
            if(a1) a1.setAttribute("aria-label", "open slide-cart-hq");
            if(a1Mobile) a1Mobile.setAttribute("aria-label", "open slide-cart-hq");
            // header - nav - user
            let a2 = document.querySelector("a.nav-link.icon-btn.nav-link-highlight.lh-1.icon-wrap-sm");
            let a2Mobile = document.querySelector("a.icon-btn.icon-wrapper.flex-center.lead.lh-1.nav-link.gray-600.no-transition.js-no-transition");
            if(a2) a2.setAttribute("aria-label", "open user login profile");
            if(a2Mobile) a2Mobile.setAttribute("aria-label", "open user login profile");
            // footer - contact
            let a3 = document.querySelectorAll("a.link-footer.dark.text-decoration-none.icon-wrap-md");
            if(a3 && a3.length > 0) { Array.from(a3).forEach(contact => { contact.setAttribute("aria-label", "Contact Us"); }); }
        }
        readyHandles.push(fixIndexAnchors);

        // fixments 004: Hub Launcher Widget
        function fixHubLauncherWidget() {
            if(!countObject.fixHubLauncherWidget) countObject.fixHubLauncherWidget = 0; if(countObject.fixHubLauncherWidget > 10) { if(window.tickHubLauncherWidget) clearTimeout(window.tickHubLauncherWidget); return; }
            let obj = document.querySelector("[data-testid='hub-widget-container'] button[shape='rounded'][aria-label='Open chat']");
            if(!obj) { if(window.tickHubLauncherWidget) clearTimeout(window.tickHubLauncherWidget); countObject.fixHubLauncherWidget += 1; window.tickHubLauncherWidget = setTimeout(fixHubLauncherWidget, 500); return; }
            // do-it area
            // 1: parent set to landmark element
            obj.parentNode.setAttribute("role", "region");
            // 2: svg fixment
            let icons = obj.querySelectorAll("svg");
            Array.from(icons).forEach((icon) => { icon.setAttribute("aria-label", "Open chat"); });
        }
        readyHandles.push(fixHubLauncherWidget);
        
        onDomReady(() => { if(readyHandles.length > 0) { readyHandles.forEach(handle => { if(!handle) return; try{ handle.call(); }catch(error){} }); } });
    }
})()